import { NotFound } from "@app/shared/ErrorPages";
import { FC, useContext } from "react";
import { Route, Switch } from "react-router-dom"
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";
import { UserContext } from "@app/user/UserContext";
import Roles from "@app/user/roles";
import MarketExpansionDashboard from "@app/overviews/market-expansion-dashboard/MarketExpansionDashboard";
import BenchmarkingDashboard from "@app/overviews/network-benchmarking-dashboard/BenchmarkingDashboard";
import EcdReportGenerationWizard from "@app/overviews/enterprise-compliance-dashboard/EcdReportGenerationWizard";
import EnterpriseComplianceDashboard from "@app/overviews/enterprise-compliance-dashboard/EnterpriseComplianceDashboard";

const OverviewsRouter: FC = () => {
  const user = useContext(UserContext);
  const featureFlags = useContext(FeatureFlagContext).enabledFeatureFlags;

  if (!user) {
    return <NotFound />;
  }

  return (
    <Switch>
      {(user.roles.includes(Roles.ENTERPRISE_COMPLIANCE_DASHBOARD_USER)) ? (
        <Route path="/overviews/enterprise-compliance-dashboard/generate-report" component={EcdReportGenerationWizard} />
      ) : (
        null
      )}

      {(user.roles.includes(Roles.ENTERPRISE_COMPLIANCE_DASHBOARD_USER)) ? (
        <Route path="/overviews/enterprise-compliance-dashboard" component={EnterpriseComplianceDashboard} />
      ) : (
        null
      )}

      {(user.roles.includes(Roles.COMPETITIVE_INSIGHTS_USER)) ? (
        <Route path="/overviews/competitive-insights-dashboard" component={BenchmarkingDashboard} />
      ) : (
        null
      )}

      ({featureFlags.has(Features.NETWORK_PERFORMANCE_MARKET_EXPANSION) ? (
        <Route path="/overviews/market-expansion-dashboard" component={MarketExpansionDashboard} />
      ) : (
        null
      )}

      <Route component={NotFound} />
    </Switch>
  );
};

export default OverviewsRouter;